import {useEffect} from 'react';

export const SCROLL_TO_TOP_X_OFFSET_CSS_VARIABLE = '--scroll-to-top-x-offset';
export const SCROLL_TO_TOP_Y_OFFSET_CSS_VARIABLE = '--scroll-to-top-y-offset';

export const useSetScrollToTopOffset = () => {
  useEffect(() => {
    return () => {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setScrollToTopOffset({axis: 'x', offset: undefined});
      setScrollToTopOffset({axis: 'y', offset: undefined});
    };
  }, []);

  return {setScrollToTopOffset};
};

const setScrollToTopOffset = ({
  axis,
  offset,
}: {
  axis: 'x' | 'y';
  offset: string | undefined;
}) => {
  const scrollToTopCssVariable =
    axis === 'x'
      ? SCROLL_TO_TOP_X_OFFSET_CSS_VARIABLE
      : SCROLL_TO_TOP_Y_OFFSET_CSS_VARIABLE;

  if (!offset) {
    document.documentElement.style.removeProperty(scrollToTopCssVariable);
    return;
  }

  document.documentElement.style.setProperty(scrollToTopCssVariable, offset);
};
